const rail = {
  rails: "Rel", // translated 
  senior: "Senior", // translated 
  seniors: "Senior", // translated 
  youths: "Pemuda", // translated 
  yearOld: "tahun", // translated 
  yearsOld: "tahun", // translated 
};


export default rail;
